import React/*, { useState, useEffect, Fragment }*/ from 'react';
import { IconButton, Typography } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import LastPageIcon from '@mui/icons-material/LastPage';

export default function JSTablePagination(props) {
    const count = props.count
    const rowsPerPage = props.rowsPerPage
    const page = props.page
    const disabled = props.disabled

    const lastPage = (rowsPerPage===0)?0:(Math.ceil(count/rowsPerPage)-1)

    let fromRows = page*rowsPerPage+1
    if(fromRows>count){
        fromRows = count
    }

    let toRows = (page+1)*rowsPerPage
    if(toRows>count){
        toRows = count
    }

    return (
        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', minHeight: 52}}>
            <div>
                {props.children}
            </div>
            <div style={{display: 'flex',alignItems: 'center'}}>
                {<Typography variant='body2' style={{marginRight: 20}}><span>{fromRows}-{toRows} of {count}</span></Typography>}
                {(lastPage>1)&&<IconButton
                    onClick={()=>{props.onChangePage(0)}}
                    disabled={disabled || page===0}
                    size="large">
                    <FirstPageIcon/>
                </IconButton>}
                <IconButton
                    onClick={()=>{props.onChangePage(page-1)}}
                    disabled={disabled || page===0}
                    size="large">
                    <ChevronLeftIcon/>
                </IconButton>
                <IconButton
                    onClick={()=>{props.onChangePage(page+1)}}
                    disabled={disabled || page===lastPage}
                    size="large">
                    <ChevronRightIcon/>
                </IconButton>
                {(lastPage>1)&&<IconButton
                    onClick={()=>{props.onChangePage(lastPage)}}
                    disabled={disabled || page===lastPage}
                    size="large">
                    <LastPageIcon/>
                </IconButton>}
            </div>
        </div>
    );
}